/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Failed_ApprovalInputs */



/**
* | output |
* | --- |
* | "Failed Approval" |
*
* @param {Editor_Filter_Failed_ApprovalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_failed_approval = /** @type {((inputs?: Editor_Filter_Failed_ApprovalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Failed_ApprovalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approbation echouee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigung fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvazione non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не пройдена проверка.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobación fallida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审批失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認失敗")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमोदन में असफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovação Reprovada")
	return /** @type {LocalizedString} */ ("Failed Approval")
});